import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useLanguage } from '../../Commun/contexts/LanguageContext';
import { Template } from '../components/TemplateLibrary';
import { WindowType } from '../services/windowsApi';
import { DoorTypeEnum } from '../services/doorsApi';

interface TemplateFormProps {
    formData: Partial<Template>;
    onChange: (data: Partial<Template>) => void;
    designMode: 'window' | 'door';
}

const TemplateForm: React.FC<TemplateFormProps> = ({ formData, onChange, designMode }) => {
    const { t } = useLanguage();

    return (
        <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
                <TextField
                    label={t('maker.field.name')}
                    fullWidth
                    value={formData.name || ''}
                    onChange={(e) => onChange({ ...formData, name: e.target.value })}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={t('maker.field.description')}
                    fullWidth
                    value={formData.description || ''}
                    onChange={(e) => onChange({ ...formData, description: e.target.value })}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Icon (Emoji)"
                    fullWidth
                    value={formData.icon || ''}
                    onChange={(e) => onChange({ ...formData, icon: e.target.value })}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('maker.field.width')}
                    type="number"
                    fullWidth
                    value={formData.defaultWidth || 1000}
                    onChange={(e) => onChange({ ...formData, defaultWidth: parseFloat(e.target.value) })}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('maker.field.height')}
                    type="number"
                    fullWidth
                    value={formData.defaultHeight || 2000}
                    onChange={(e) => onChange({ ...formData, defaultHeight: parseFloat(e.target.value) })}
                />
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <InputLabel>Internal Type</InputLabel>
                    <Select
                        value={designMode === 'window' ? (formData.windowType || WindowType.Casement) : (formData.doorType || DoorTypeEnum.Single)}
                        label="Internal Type"
                        onChange={(e) => {
                            if (designMode === 'window') {
                                onChange({ ...formData, windowType: e.target.value as WindowType })
                            } else {
                                onChange({ ...formData, doorType: e.target.value as DoorTypeEnum })
                            }
                        }}
                    >
                        {designMode === 'window' ? (
                            Object.values(WindowType).filter(v => typeof v !== 'number').map(t => (
                                <MenuItem key={t} value={t}>{t}</MenuItem>
                            ))
                        ) : (
                            Object.values(DoorTypeEnum).filter(v => typeof v !== 'number').map(t => (
                                <MenuItem key={t} value={t}>{t}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default TemplateForm;
